import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
let default_1 = class extends Vue {
    timeID;
    fetchDataByInterval(func) {
        func();
        this.timeID = setTimeout(() => {
            this.fetchDataByInterval(func);
        }, 60000);
    }
    beforeDestroy() {
        this.timeID && clearTimeout(this.timeID);
    }
};
default_1 = __decorate([
    Component({
        name: 'time-mixin',
    })
], default_1);
export default default_1;
